import { useEffect } from 'react';
import { notification, Space, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { isArray } from 'lodash';
import moment from 'moment';
import useErrorDictionary from './useErrorDictionary';

const { Text } = Typography;

const useServiceError = (error) => {
  const intl = useIntl();
  const useDictionaryError = useErrorDictionary();

  const handleObjError = (err) => {
    if ((err.code && err.message) || err.message) {
      if (err.message.includes('tb_user_email_key')) {
        return handleDuplicateEmailError(err);
      }
      if (err.message.includes('tb_user_login_key')) {
        return handleDuplicateUserError(err);
      } else {
        const errorMessageFound = useDictionaryError.find((error) =>
          err.message.includes(error.message),
        );
        if (errorMessageFound) {
          notification.error({
            message: intl.formatMessage({ id: errorMessageFound.title }),
            description: intl.formatMessage({ id: errorMessageFound.labelId }),
          });
        } else {
          notification.error({ message: err.code, description: err.message });
        }
      }
    } else if (err.status && err.path && err.timestamp) {
      notification.error({
        message: <Text level={4}>{err.status}</Text>,
        description: (
          <Space direction="vertical" size="small">
            {err.message && <Text>Mensagem: {err.message}</Text>}
            <Text>
              Path:&nbsp;
              {err.path}
            </Text>
            <Text>
              Timestamp:&nbsp;
              {moment(err.timestamp).format('DD/MM/YYYY hh:MM:ss')}
            </Text>
          </Space>
        ),
      });
    } else {
      notification.error({
        message: 'Erro na requisição',
        description: err.message || 'Não foi possível finalizar a requisição',
      });
    }
  };

  const handleArrayError = (err) => {
    err.map((item) => {
      const errorMessageFound = useDictionaryError.find((error) =>
        item.message.includes(error.message),
      );

      if (errorMessageFound) {
        notification.error({
          message: intl.formatMessage({ id: errorMessageFound.title }),
          description: intl.formatMessage({ id: errorMessageFound.labelId }),
        });
      } else {
        notification.error({ id: item.code, description: item.message });
      }
    });
  };

  const handleGenericError = () => {
    notification.error({
      message: intl.formatMessage({ id: 'commons.errors.generic.message' }),
      description: intl.formatMessage({
        id: 'commons.errors.generic.description',
      }),
    });
  };

  const handleDuplicateEmailError = () => {
    let email = '';

    if (error?.response && error?.response.config) {
      const { config } = error.response;
      const { user } = JSON.parse(config.data);

      email = user.email;
    }

    notification.error({
      message: intl.formatMessage({
        id: 'register.form.notification.error.duplicateEmail',
      }),
      description: intl.formatMessage(
        {
          id: 'register.form.notification.error.duplicateEmail.description',
        },
        { email },
      ),
    });
  };

  const handleDuplicateUserError = () => {
    let loginDuplicate = '';

    if (error?.response && error?.response.config) {
      const { config } = error.response;
      const { user } = JSON.parse(config.data);

      loginDuplicate = user.login;
    }

    notification.error({
      message: intl.formatMessage({
        id: 'register.form.notification.error.duplicateUser',
      }),
      description: intl.formatMessage(
        {
          id: 'register.form.notification.error.duplicateUser.description',
        },
        { loginDuplicate },
      ),
    });
  };

  useEffect(() => {
    if (error) {
      if (error.isAxiosError) {
        const data = error?.response?.data;
        if (error?.response?.status !== 403) {
          if (data) {
            if (isArray(data)) {
              handleArrayError(data);
            } else {
              handleObjError(data);
            }
          } else {
            handleGenericError();
          }
        }
      } else {
        handleGenericError();
      }
    }
  }, [error]);
};

export default useServiceError;
